import styled from 'styled-components';

export const PageWrapper = styled.div`
  padding: 16px 20px;
  background: #1a1a1a;
  min-height: calc(100vh - 50px);
  font-family: 'Source Sans 3', system-ui, -apple-system, sans-serif;
`;

export const DarkCard = styled.div`
  background: #222;
  border-radius: 12px;
  padding: 16px;
  border: 1px solid #2e2e2e;

  .card-title {
    font-size: 14px;
    font-weight: 600;
    color: #e0e0e0;
    margin-bottom: 12px;
    text-align: center;
  }
`;

export const PieLegend = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 8px;
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  color: #c0c0c0;

  .dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: ${props => props.color};
    flex-shrink: 0;
  }
`;

export const MainGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
  margin-bottom: 14px;
`;

export const BottomGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 14px;
  margin-bottom: 14px;
`;

export const LoadingOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  backdrop-filter: blur(2px);
`;

export const Spinner = styled.div`
  width: 40px;
  height: 40px;
  border: 4px solid rgba(186, 149, 94, 0.2);
  border-top: 4px solid #BA955E;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;
